import React from "react";
import { usePermissionTabs } from "../../hooks/usePermissionTabs";
import { PermissionTabManager } from "../../components/PermissionTabManager";
import RequestsTab from "./_components/RequestsTab";
// import ReturnShipmentTab from "./_components/ReturnShipmentTab";




const ALL_TABS = [
  {
    key: "Pickup Manifest",
    label: "Pickup Manifest",
    component: <RequestsTab />,
    modules: ["pickup_manifests"],
    operation: "read",
  },
  
  // {
  //   key: "Return Manifest",
  //   label: "Return Manifest",
  //   component: <ReturnShipmentTab />,
  //   modules: ["return_to_shipper"],
  //   operation: "read",
  // },
];

const PickupManagement: React.FC = () => {
  const result = usePermissionTabs({
    tabs: ALL_TABS,
    param: "tab",
  });

  return (
    <PermissionTabManager
      title="Manifest"
      visibleTabs={result.visibleTabs}
      activeLabel={result.activeLabel}
      content={result.content}
      isLoading={result.isLoading}
      permissionsReady={result.permissionsReady}
      error={result.error}
      handleChange={result.handleChange}
    />
  );
};

export default PickupManagement;
